import { render } from "./DashboardOptionsRestoreModal.vue?vue&type=template&id=44cadcc0&scoped=true&ts=true"
import script from "./DashboardOptionsRestoreModal.vue?vue&type=script&lang=ts"
export * from "./DashboardOptionsRestoreModal.vue?vue&type=script&lang=ts"

import "./DashboardOptionsRestoreModal.vue?vue&type=style&index=0&id=44cadcc0&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cadcc0"]])

export default __exports__